import AntIcon from '@ant-design/icons';
import classnames from 'classnames';
import React from 'react';
import './style.scss';

interface IconProps {
  icon: string;
  color?: string;
  size?: number;
  component?: React.ComponentType<any>;
  className?: string;
  primary?: boolean;
}

const Icon: React.FC<IconProps> = ({
  icon,
  color,
  size = 16,
  component,
  className = '',
  primary,
}) => {
  if (!icon && !component) {
    return null;
  }
  return component ? (
    <AntIcon
      className={`icon ${className}`}
      component={component}
      style={{ color, fontSize: `${size}px` }}
    />
  ) : (
    <span
      className={classnames({
        [`icon icon-${icon}`]: true,
        [className]: className,
        primary,
      })}
      style={{ color, fontSize: `${size}px` }}
    >
      <span className="path1" />
      <span className="path2" />
    </span>
  );
};

export default Icon;
